<template>
    <!-- <div class="pageWrapper" :style="{'backgroundImage': backgroundImage}"> -->
    <div class="pageWrapper" :style="styleObject">
        <div class="pageContainer">
            <slot/>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PageWrapper',
    props:['bgImage'],
    data() {
        return {
            styleObject: {
                backgroundImage: 'url("' + this.bgImage + '")'
            }
        }
    }
}
</script>

<style lang="scss" >
    .pageWrapper {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        padding: 3rem;
        background-size: cover;
        background-position: center;
    }

    .pageContainer {
        position: relative;
        width: 100%;
        height: 100%;
    }
</style>
